import React from 'react';
import { Table, Spinner } from 'react-bootstrap';
import '../stylesheets/ModalOp.css';
class TerminalInfoList extends React.Component {

    render() {
        const title = [
            'siteID', 'ituVersion', 'ituModel', 'ituSoftwareVersion', 'ituSerialNumber', 'ituTimestampPowerOn1', 'ituTimestampPowerOn2'
        ];
        return (
            <div className="top-spacing">
                {this.props.showSpinner ?
                    <Spinner animation="border" variant="primary" />
                    :
                    this.props.data.error ?
                        <div>
                            {this.props.data.error}
                        </div>
                        :
                        <Table bordered size="sm">
                            <tbody className="table-text-justify">
                                {title.map((key, i) => (
                                    <tr key={i}>
                                        <td>{this.props.translation[key]}</td>
                                        <td>{(this.props.data.terminal[key]).toString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                }
            </div>
        );

    }
}
export default TerminalInfoList;